/* The brand chip inside the modal, brought into line with the hero.

   The hero's brand chip carries the lengthways wordmark from
   snippets/fx-marks.liquid, injected by fx-pickbar.js. The modal's chip was
   still showing the shield emblem at 150 by 59, which is a logo rather than a
   chip and towered over a row of 46px controls. This puts the same wordmark in
   the same place so a customer meets one brand chip, not two.

   THE ORIGINAL IMG IS HIDDEN, NOT REMOVED. Its alt attribute is the only
   reliable statement of which brand is currently selected, and the extension
   updates that img in place on a brand change rather than rebuilding the
   button. Remove it and the chip has no way of knowing what it is showing.

   THE DEBOUNCE IS A TIMER, NOT requestAnimationFrame. rAF does not run in a
   tab that is not being painted, so a queued flag set on a mutation is never
   cleared and every mutation after it is silently dropped. Measured, in this
   file's sibling: the work stopped dead and the script still looked alive.

   Everything here is additive. If snippets/fx-marks.liquid is not on the page
   the chip keeps the emblem and nothing else changes. */
(function () {
  var SWITCH = '.vin-fx-brand-switch';
  var queued = null;

  function marks() {
    var tpl = document.getElementById('fx-marks');
    if (!tpl || !tpl.content) return null;
    var frag = tpl.content.cloneNode(true);
    var svgs = frag.querySelectorAll('svg');
    if (!svgs.length) return null;
    var wrap = document.createElement('span');
    wrap.className = 'fx-pb__marks';
    wrap.setAttribute('aria-hidden', 'true');
    [].forEach.call(svgs, function (s) { wrap.appendChild(s); });
    return wrap;
  }

  function sync() {
    queued = null;
    var buttons = document.querySelectorAll(SWITCH);
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var img = btn.querySelector('.vin-fx-bar-logo');
      if (!img) continue;

      if (!btn.querySelector('.fx-pb__marks')) {
        var mk = marks();
        if (!mk) continue;
        img.parentNode.insertBefore(mk, img);
      }
      if (img.style.display !== 'none') img.style.display = 'none';

      var brand = /shiftr/i.test(img.getAttribute('alt') || '') ? 'shiftr' : 'futura';
      if (btn.getAttribute('data-fx-brand') !== brand) {
        btn.setAttribute('data-fx-brand', brand);
      }
    }
  }

  /* Coalesced to one pass per burst. Rendering the parts grid alone fires the
     observer dozens of times in a row and there is no sense answering each
     one. data-fx-brand is written back as an attribute and only alt is
     observed, so this cannot re-enter itself. */
  function schedule() {
    if (queued) return;
    queued = window.setTimeout(sync, 60);
  }

  function boot() {
    sync();
    if (!window.MutationObserver) return;
    new window.MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['alt']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
